exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-indicator{height:0;left:50%;margin:0;margin-right:-50%;position:fixed;top:50%;transform:translate(-50%,-50%);z-index:3}.spinner{text-align:center}.spinner>.dotspace{animation:bouncedelay 1.4s infinite ease-in-out;animation-fill-mode:both;background-color:#367c2b;border-radius:100%;display:inline-block;height:18px;margin:.4em;width:18px}.spinner .bounce1{animation-delay:-.64s}.spinner .bounce2{animation-delay:-.32s}.spinner .bounce3{animation-delay:-.16s}@keyframes bouncedelay{0%,80%,to{transform:scale(.5)}40%{transform:scale(1)}to{opacity:.1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/warranty-loading-indicator.scss
// module id = 5288
// module chunks = 0